"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

import Icon from "@/components/ui/AppIcon";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Our Story", href: "#story" },
    { label: "Bikes edited", href: "#bikes" },
    { label: "Categories", href: "#categories" },
    { label: "Reviews", href: "#reviews" },
    { label: "Products", href: "/products" },
  ];

  return (
    <header
      className={`fixed top-0 w-full z-50 px-4 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div
        className={`max-w-7xl mx-auto flex items-center justify-between bg-blue-600 rounded-2xl px-6 py-3 transition-all duration-500 ${
          scrolled ? "shadow-card" : ""
        }`}
      >
        {/* Logo */}
        <Link href="/homepage" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-xl bg-charcoal flex items-center justify-center group-hover:bg-amber transition-colors duration-300">
            <Icon name="TruckIcon" size={18} className="text-cream" />
          </div>
          <span className="font-heading text-xl font-bold text-charcoal tracking-tight">
            Velocity<span className="text-amber italic font-normal">Cycles</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-stone-warm">
          {navLinks?.map((link) => (
            link?.href?.startsWith("/") ? (
              <Link
                key={link?.href}
                href={link?.href}
                className="hover:text-charcoal transition-colors duration-200 relative group"
              >
                {link?.label}
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-amber group-hover:w-full transition-all duration-300 rounded-full" />
              </Link>
            ) : (
              <a
                key={link?.href}
                href={link?.href}
                className="hover:text-charcoal transition-colors duration-200 relative group"
              >
                {link?.label}
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-amber group-hover:w-full transition-all duration-300 rounded-full" />
              </a>
            )
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="/products"
            className="btn-amber px-5 py-2.5 rounded-full text-sm font-bold"
          >
            Shop Now
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-stone-border/40 transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <Icon
            name={mobileOpen ? "XMarkIcon" : "Bars3Icon"}
            size={22}
            className="text-charcoal"
          />
        </button>
      </div>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden mt-2 mx-4 nav-glass rounded-2xl p-6 shadow-card">
          <nav className="flex flex-col gap-4">
            {navLinks?.map((link) => (
              link?.href?.startsWith("/") ? (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="text-sm font-medium text-charcoal hover:text-amber transition-colors py-1"
                  onClick={() => setMobileOpen(false)}
                >
                  {link?.label}
                </Link>
              ) : (
                <a
                  key={link?.href}
                  href={link?.href}
                  className="text-sm font-medium text-charcoal hover:text-amber transition-colors py-1"
                  onClick={() => setMobileOpen(false)}
                >
                  {link?.label}
                </a>
              )
            ))}
            <a
              href="/products"
              className="btn-amber px-5 py-3 rounded-full text-sm font-bold text-center mt-2"
              onClick={() => setMobileOpen(false)}
            >
              Shop Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}